import { SEO } from '../../seo/useSEO';
import { t } from '../../i18n/pt';
import styles from './MaintenancePage.module.scss';

interface Props {
  message?: string | null;
}

export default function MaintenancePage({ message }: Props): JSX.Element {
  const body = message?.trim() ? message.trim() : t.maintenance.message;

  return (
    <>
      <SEO title={t.maintenance.title} noindex />
      <main className={styles.page}>
        <div className={styles.inner}>
          <span className={styles.wordmark}>Rosita Store</span>
          <p className={styles.eyebrow}>{t.maintenance.eyebrow}</p>
          <h1 className={styles.title}>{t.maintenance.title}</h1>
          <p className={styles.message}>{body}</p>
          <p className={styles.contact}>
            {t.maintenance.contactLead}{' '}
            <a href={`mailto:${t.maintenance.contactEmail}`}>{t.maintenance.contactEmail}</a>
          </p>
        </div>
      </main>
    </>
  );
}
